import { IAvatarPerson } from '../interfaces/avatar.interface';

export const getFullName = (
    person: Pick<IAvatarPerson, 'firstName' | 'lastName' | 'email'>,
): string => `${person.firstName} ${person.lastName}`.trim() || person.email;

// A picked calendar day as YYYY-MM-DD, in the person's own time zone, as a date filter sends it.
export const formatDateToLocalISO = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
